import * as React from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
} from 'react-admin';

const InstanceCreate = props => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="name" />
            <TextInput source="slug" />
        </SimpleForm>
    </Create>
);

export default InstanceCreate;